import options from "./industry-options.json";

/** Human-readable industry labels for lead forms; includes "Other" as the last option. */
export const INDUSTRY_OPTIONS = options as readonly string[];

export const INDUSTRY_OPTION_SET = new Set<string>(INDUSTRY_OPTIONS);

export function isAllowedIndustry(value: string): boolean {
  const t = value.trim();
  if (t.length === 0) return true;
  return INDUSTRY_OPTION_SET.has(t);
}
